import { ThemeApp } from 'themes/types/themeApp/theme.types';
import { themeUi } from '../../themeUi/themeUi';

export const userProfile: ThemeApp['appComponents']['userProfile'] = {
  components: {
    sharedStyles: {
      cardBox: {
        backgroundColor: themeUi.semantic.color.background.secondary950
      },
      cardHeader: {
        color: themeUi.semantic.color.text.secondary0,
        borderBottom: themeUi.semantic.color.border.secondary800
      }
    },
    userDetailsCard: {
      fieldValue: {
        color: themeUi.semantic.color.text.secondary0
      }
    },
    mfaCard: {
      components: {
        optionCard: {
          borderColor: themeUi.semantic.color.border.secondary800
        },
        sms: {
          setupForm: {
            phoneNumberContainer: {
              telFlagDropDownBackgroundColor: themeUi.semantic.color.background.secondary950,
              selectedFlagBackgroundColor: themeUi.semantic.color.background.neutral500,
              inputFlagDropDownBackgroundColor: themeUi.semantic.color.border.neutral500,
              inputFlagDropDownErrorBackgroundColor: themeUi.semantic.color.border.danger500,
              inputFlagDropDownErrorHoverBackgroundColor: themeUi.semantic.color.border.primary400
            }
          }
        },
        authenticator: {
          info: {
            color: themeUi.semantic.color.text.neutral600
          },
          components: {
            appSetupModal: {
              components: {
                bullet: {
                  bulletIndex: {
                    backgroundColor: themeUi.semantic.color.background.primary200,
                    color: themeUi.semantic.color.text.primary600
                  },
                  bulletLabel: {
                    color: themeUi.semantic.color.text.secondary0
                  }
                }
              },
              qrCodeContainer: {
                backgroundColor: themeUi.semantic.color.background.neutral200
              },
              qrManualText: {
                colorNormal: themeUi.semantic.color.text.secondary0,
                colorBold: themeUi.semantic.color.text.primary600
              }
            }
          }
        }
      }
    }
  }
};
